/**
 * What a workspace's AI limits may be set to — the settings form's inputs and
 * `PATCH /workspaces/:id/settings` both read these, so the form cannot offer a
 * value the route refuses. The DEFAULT is not here: it is the `workspaces`
 * column default, read by the API (`lib/ai-limits.ts`) and sent to the client
 * as the effective value.
 */
export const AI_LIMIT_BOUNDS = {
    /** Requests per minute to OpenRouter, per AI service instance. */
    rateLimitRpm: { min: 1, max: 100 },
    /** `max_tokens` on each completion — a ceiling, not a spend. */
    maxTokens: { min: 1000, max: 128000 },
};
/**
 * The confidence an AI category guess needs before it is APPLIED to a
 * transaction (uiv2 SET-39); below it the transaction stays uncategorised for a
 * person to decide. The mockup's slider range. The default is the `workspaces`
 * column default (0.50 — the value `refresh-ai` had as a literal), read by the API.
 */
export const AUTO_CATEGORIZE_CONFIDENCE_BOUNDS = { min: 0.5, max: 1 };
//# sourceMappingURL=ai-limits.js.map